"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TicketFilters = _interopRequireDefault(require("../TicketFilters"));
var _TicketStatus = require("../TicketStatus");
var _userflow = require("../../../../utils/userflow");
var _excluded = ["count", "currentManager", "onFilter"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FILTER_NAMES = _TicketFilters["default"].FILTER_NAMES;
var ticketPluralize = ['тикет требует', 'тикета требуют', 'тикетов требуют'];
var TicketListAttention = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var count = _ref.count,
    currentManager = _ref.currentManager,
    onFilter = _ref.onFilter,
    restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var handleFilter = (0, _react.useCallback)(function () {
    onFilter((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, FILTER_NAMES.STATUSES, [_TicketStatus.STATUSES.WAIT_FOR_SERVICE]), FILTER_NAMES.MANAGERS, [currentManager.id]));
  }, [onFilter]);
  return /*#__PURE__*/_react["default"].createElement(StyledButton, (0, _extends2["default"])({
    onClick: handleFilter
  }, restProps), "".concat((0, _userflow.formatDecimal)(count), " ").concat((0, _userflow.pluralize)(count, ticketPluralize), " \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F"));
});
TicketListAttention.displayName = 'TicketListAttention';
TicketListAttention.propTypes = {
  className: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  currentManager: _propTypes["default"].shape({
    id: _propTypes["default"].number.isRequired
  })
};
TicketListAttention.defaultProps = {
  className: ''
};
var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "TicketListAttention__StyledButton",
  componentId: "sc-zprl6c-0"
})(["display:flex;align-items:center;justify-content:center;color:#17181a;font-size:12px;line-height:16px;padding:3px 0;margin:0 10px 8px 0;background-color:#fffbe5;border-radius:4px;border:none;outline:none;cursor:pointer;"]);
var _default = exports["default"] = TicketListAttention;